/** Must match backend list validators (`*.max(100)` on pageSize). */
export const API_MAX_PAGE_SIZE = 100;

export function clampPageSize(pageSize?: number): number | undefined {
  if (pageSize === undefined) return undefined;
  const n = Math.floor(pageSize);
  if (!Number.isFinite(n) || n < 1) return undefined;
  return Math.min(API_MAX_PAGE_SIZE, n);
}

export function clampListQuery<T extends { page?: number; pageSize?: number }>(query: T): T {
  const out = { ...query };
  if (out.pageSize !== undefined) {
    const clamped = clampPageSize(out.pageSize);
    if (clamped === undefined) delete out.pageSize;
    else out.pageSize = clamped;
  }
  if (out.page !== undefined) {
    const page = Math.floor(out.page);
    if (!Number.isFinite(page) || page < 1) delete out.page;
    else out.page = page;
  }
  return out;
}
